export const STATUS_DIAPLAY_MAP = Object.freeze({
	CANCELED: 'Link expired',
});
